var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200.4 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.94,0c4.18,0,8.35,0,12.53,0,.5.11,1,.28,1.51.32,15.05,1.13,29.2,5.33,42.17,13.03,26.65,15.82,42.99,38.96,48.73,69.43.68,3.63,1.03,7.32,1.54,10.98v12.5c-.5,3.6-.89,7.22-1.5,10.79-7.95,46.18-47.19,80.83-94.11,82.84-24.49,1.05-46.64-5.86-65.99-20.96C18.5,163.1,6.03,142.41,1.5,117.05.86,113.48.49,109.86,0,106.26c0-4.17,0-8.33,0-12.5.16-1.28.33-2.56.47-3.84,2.36-21.61,10.66-40.64,25.28-56.77C41.22,16.08,60.36,5.45,83.13,1.51c3.58-.62,7.2-1.01,10.81-1.51ZM158.87,59.86H41.56c.68.72,1.14,1.23,1.63,1.72,15.58,15.55,31.31,30.96,46.64,46.76,3.87,3.99,7.68,6.12,13.2,5.33,1.42-.2,2.51-.46,3.57-1.52,16.84-16.87,33.72-33.7,50.6-50.54.5-.49.97-1.01,1.68-1.75ZM121.65,106.5c-4.03,4.03-8.01,8.16-12.17,12.07-.98.92-2.57,1.51-3.94,1.62-2.91.24-5.88-.1-8.79.12-3,.24-5.18-.73-7.21-2.95-3.46-3.78-7.2-7.31-10.64-10.75-11.33,11.3-22.5,22.45-33.58,33.51h110.02c-11.2-11.18-22.34-22.3-33.69-33.63ZM73.17,101.74c-12.09-12.07-24.31-24.27-36.35-36.29v72.58c12.23-12.21,24.43-24.38,36.35-36.29ZM163.61,138.33v-72.84c-12.1,12.07-24.32,24.28-36.49,36.42,11.96,11.93,24.12,24.08,36.49,36.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMail);
export default __webpack_public_path__ + "static/media/eMail.ee7b40883b62f2cf67b75cb071329513.svg";
export { ForwardRef as ReactComponent };